module.exports = __webpack_public_path__ + "media/tw.21291ae9.svg";